import React from "react";
import { useTranslation } from "react-i18next";
import { StyledPrimaryButton } from "../../../components/styled";

const SaveButton = ({
  onClick,
  isLoading,
  isDisabled,
}: {
  onClick: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <StyledPrimaryButton
      onClick={onClick}
      text={t("greco.save")}
      disabled={isDisabled}
      iconProps={{
        iconName: isLoading ? "ProgressRingDots" : "",
      }}
    />
  );
};

export default SaveButton;
